
const SF_PROJECT = {
    trackingUrl: 'https://log.splitforger.com',
    groups: ['focuscontent0', 'focuscontent1'],
    variations: [
        {
            id: '889112',
            name: 'Hide Content',
            urlRegex: '/products/',
            css: '.product-info__complementary-products, .klaviyo-wishlist-slot, .shopify-section--product-recommendations, #etrusted-trusted_stars_service, premium-content-atfn3rytgvddqsuovraigenblockd631976wdrmrc, .shopify-section--featured-collection, [id*=seo_blocks] {display:none !important;}',
            js: '',
            groups: ['focuscontent1']
        }
    ],
    default: {
        js: ""
    }
};

class SplitForger {

    static localStorageKey = 'splitforger_store';

    constructor(forced_group) {

        this.tid = this.get('tid');
        if (!this.tid) {
            this.tid = this.random();
            this.set('tid', this.tid);
        }

        if (forced_group) {

            //if (!SF_PROJECT.groups.includes(forced_group)) throw new Error('invalid group');

            this.group = forced_group;

            this.set('test_group', this.group);
            this.set('test_group_updated', Date.now());

        }

        this.assignGroup();

        this.out(this.group, SF_PROJECT.groups);
        this.applyChanges();

        this.attachToCart();
        this.trackPageView();

    }

    out(...args) {
        console.log('SplitForger:', ...args);
    }

    get(key) {
        try {
            const data = JSON.parse(localStorage.getItem(SplitForger.localStorageKey) || '{}');
            return data[key];
        } catch {
            return undefined;
        }
    }

    set(key, val) {

        if (val === undefined) throw new Error(`no value specified: ${key}; ${val}`);

        let data = {};
        try {
            data = JSON.parse(localStorage.getItem(SplitForger.localStorageKey) || '{}');
        } catch { }

        data[key] = val;
        localStorage.setItem(SplitForger.localStorageKey, JSON.stringify(data));
    }

    random() {

        const randomHex = (Math.random() * 0xFFFFFFFFFFFFF).toString(16).slice(0, 10);
        return randomHex;

    }

    assignGroup() {

        this.group = this.get('test_group');

        if (!SF_PROJECT.groups.includes(this.group)) {
            this.out('outdated group assigned', this.group);
            this.group = null;
        }

        if (this.group) return;

        this.group = SF_PROJECT.groups[Math.floor(Math.random() * SF_PROJECT.groups.length)];

        this.set('test_group', this.group);
        this.set('test_group_updated', Date.now());
    }

    applyChanges() {

        const path = document.location.pathname;

        const selected_variations = SF_PROJECT.variations.filter((v) => {
            return v.groups.includes(this.group) && (v.urlRegex === null || path.match(v.urlRegex) !== null);
        });

        this.out(selected_variations);

        const combined_css = [SF_PROJECT.default.css || '',
        ...selected_variations.map(v => v.css || '')].join('\n\n');

        const elem = document.createElement('style');
        elem.setAttribute('data-sf', '1');
        elem.textContent = combined_css;

        document.head.append(elem);

        eval(SF_PROJECT.default.js);

        for (let v of selected_variations) {
            if (!v.js) return;
            eval(v.js);
        }

    }

    attachToCart() {
        setTimeout(async () => {

            const root = window.Shopify?.routes?.root || '/';

            const newAttributes = {
                sf_group: this.group,
                sf_tid: this.tid
            };

            this.out('cart attr', newAttributes);

            fetch(root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    attributes: newAttributes
                })
            });

        }, 1000);
    }

    trackPageView() {
        setTimeout(() => {

            const event = {
                type: 'pageView',
                tid: this.tid,
                group: this.group,
                data: String(document.location)
            };

            fetch(SF_PROJECT.trackingUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(event)
            });

        }, 1000);
    }

};

function startSplitForger() {
    //localStorage.setItem(SplitForger.localStorageKey, '{}');
    new SplitForger();
}

function waitForCustomerPrivacy(timeout = 5000) {
    const start = Date.now();

    return new Promise((resolve, reject) => {
        const check = () => {
            if (window.Shopify?.customerPrivacy) {
                resolve(window.Shopify.customerPrivacy);
            } else if (Date.now() - start > timeout) {
                reject(new Error("Shopify.customerPrivacy not available"));
            } else {
                requestAnimationFrame(check);
            }
        };

        check();
    });
}

waitForCustomerPrivacy()
    .then((customerPrivacy) => {
        const startIfAllowed = () => {
            if (customerPrivacy.analyticsProcessingAllowed()) {
                startSplitForger();
            }
        };

        startIfAllowed();

        document.addEventListener("visitorConsentCollected", startIfAllowed);
    })
    .catch(console.error);